module.exports = __webpack_public_path__ + "static/media/rom5.a145d7bd.jpg";